import { Link } from 'react-router-dom';

const ABOUT_IMAGE =
  'https://roadtechservices.netlify.app/images/mower-repair-3-850w.jpeg';

export default function AboutSection() {
  return (
    <section className="bg-stone-50 py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative h-[520px] rounded-2xl overflow-hidden">
              <img
                src={ABOUT_IMAGE}
                alt="Road Tech Services - Matt Olenzek on-site repair"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating badge */}
            <div className="absolute -bottom-5 right-4 bg-white border border-stone-200 p-5 rounded-xl max-w-[230px]">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-9 h-9 flex items-center justify-center bg-orange-100 rounded-lg">
                  <i className="ri-award-line text-orange-600 text-base" />
                </div>
                <span className="text-neutral-900 font-semibold text-sm">
                  4 Certifications
                </span>
              </div>
              <p className="text-neutral-500 text-xs leading-relaxed">
                Briggs &amp; Stratton Master · Stihl Silver · Kohler · Kawasaki
              </p>
            </div>
          </div>

          {/* Content */}
          <div>
            <p className="text-orange-600 text-xs font-bold uppercase tracking-widest mb-4">
              About Us
            </p>
            <h2 className="font-display text-4xl lg:text-5xl font-bold uppercase tracking-tight text-neutral-900 mb-6 leading-tight">
              About Road Tech Services
            </h2>
            <p className="text-neutral-600 text-base leading-relaxed mb-4">
              Road Tech Services is a locally owned mobile repair business
              proudly serving homeowners across Michigan. We specialize in
              on-site repair and maintenance for lawn mowers, snow blowers, and
              generators — saving customers the hassle of transporting heavy
              equipment to a shop.
            </p>
            <p className="text-neutral-600 text-base leading-relaxed mb-8">
              Our mission is simple: make small engine repair convenient,
              professional, and reliable. With expert certifications and
              same-day service available, we ensure your equipment is back up
              and running quickly — right in your driveway.
            </p>

            {/* Matt's quote */}
            <div className="bg-white border-l-4 border-orange-500 pl-6 py-5 rounded-r-xl mb-8">
              <p className="text-neutral-700 text-sm leading-relaxed italic mb-4">
                &ldquo;I built this business to save people time, money, and
                stress. My goal is simple: provide reliable, professional, and
                convenient equipment repair right at your home. Whether
                it&rsquo;s your mower, snow blower, or generator — I&rsquo;ll
                keep it ready for every season.&rdquo;
              </p>
              <div>
                <span className="font-semibold text-neutral-900 text-sm block">
                  Matt Olenzek
                </span>
                <span className="text-neutral-500 text-xs">
                  Owner &amp; Master Certified Technician
                </span>
              </div>
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 bg-neutral-900 hover:bg-neutral-800 text-white font-semibold px-7 py-3.5 rounded-lg transition-colors text-sm whitespace-nowrap cursor-pointer"
            >
              More About Us
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
